export const getCurrencySymbol = (number, currency) => {
  if (currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0
    }).format(number)
  }
}
